import { AppFunctionComponent } from "../../../types"
import React, { useEffect, useState } from "react"
import { OperatingSystem } from "../../../helpers/resolver-operating-system/operating-system.enum"
import resolveOperatingSystem from "../../../helpers/resolver-operating-system/resolve-operating-system"
import { BasicButtonLink } from "../../../ui/components/link/link.component"
import { DownloadButtonProps } from "./download-button.interface"

const DownloadButton: AppFunctionComponent<DownloadButtonProps> = ({
  macUrl,
  windowsUrl,
  linuxUrl,
  googlePlayUrl,
  appStoreUrl,
}) => {
  const [operatingSystem, setOperatingSystem] = useState(
    OperatingSystem.Windows
  )

  useEffect(() => {
    setOperatingSystem(resolveOperatingSystem())
  }, [])

  const MacOsButton = () => (
    <BasicButtonLink to={macUrl}>Download for MacOS</BasicButtonLink>
  )
  const WindowsButton = () => (
    <BasicButtonLink to={windowsUrl}>Download for Windows</BasicButtonLink>
  )
  const LinuxButton = () => (
    <BasicButtonLink to={linuxUrl}>Download for Linux</BasicButtonLink>
  )
  const AndroidButton = () => (
    <BasicButtonLink to={googlePlayUrl}>Google Play</BasicButtonLink>
  )
  const IOsButton = () => (
    <BasicButtonLink to={appStoreUrl}>App Store</BasicButtonLink>
  )

  switch (operatingSystem) {
    case OperatingSystem.MacOS:
      return <MacOsButton />
    case OperatingSystem.Windows:
      return <WindowsButton />
    case OperatingSystem.Linux:
      if (linuxUrl) {
        return <LinuxButton />
      } else {
        return <WindowsButton />
      }
    case OperatingSystem.Android:
      if (googlePlayUrl) {
        return <AndroidButton />
      } else {
        return <WindowsButton />
      }
    case OperatingSystem.iOS:
      if (appStoreUrl) {
        return <IOsButton />
      } else {
        return <MacOsButton />
      }
    default:
      return <WindowsButton />
  }
}

export default DownloadButton
